<div class="justup-dialog">
  <vl-header-dialog (close)="dialogRef.close()">
    {{ data.title || "Confirmation" }}
  </vl-header-dialog>

  <div class="justup-dialog-content">
    @if (data.message) {
      <!--
        ⚠️ **Le testid porte sur le MESSAGE, pas sur le dialogue.** C'est le message qui varie selon ce
        que l'action va réellement faire (« Employé 24 fois… » vs « Rien ne l'emploie… ») : un test qui
        vérifie seulement que « une confirmation s'ouvre » passerait alors que le texte annonce le
        contraire de ce qui va se produire.
      -->
      <div class="message-row" data-testid="dialog-confirm-message">
        {{ data.message }}
      </div>
    }

    <!--
      ⚠️ **La ventilation est déléguée à `vl-usage-detail`**, partagé avec la fiche en lecture seule d'une
      entrée native : deux écrans posent la même question à deux moments (« qu'est-ce que j'archive ? » et
      « qui l'emploie ? »). Deux rendus auraient divergé, et l'un des deux aurait perdu les liens.

      ⚠️ **Le dialogue se ferme AVANT de naviguer, et sur `false`** : sinon son backdrop reste au-dessus
      de la page d'arrivée et bloque tout clic — et fermer sur `true` confirmerait la suppression au lieu
      d'ouvrir une fiche.
    -->
    <vl-usage-detail
      [details]="data.details ?? []"
      [avantNavigation]="fermerAvantNavigation"
    />

    @if (data.articles?.length) {
      <div class="articles-list">
        @for (a of data.articles; track a.articleId) {
          <div class="article-item">
            <span class="article-item__name">{{ a.denomination ?? a.articleId }}</span>
            @if (a.code) {
              <span class="article-item__code">{{ a.code }}</span>
            }
          </div>
        }
      </div>
    }

    @if (autoDelayMs > 0) {
      <div class="auto-row">
        <span class="countdown">{{ countdownSec }} s</span>
        <div class="progress-track">
          <div class="progress-bar bg-primary" [style.width.%]="progressPct"></div>
        </div>
      </div>
    }
  </div>

  <div class="justup-dialog-footer">
    <div class="flex-row ml-auto gap-12">
      @if (data.buttons) {
        @if (data.buttons.no) {
          <vl-big-button
            data-testid="btn-cancel-dialog"
            type="fit"
            color="error"
            (action)="dialogRef.close(false)"
            [text]="data.buttons.no"
          >
          </vl-big-button>
        }
        <vl-big-button
          data-testid="btn-confirm-dialog"
          type="fit"
          color="primary"
          (action)="dialogRef.close(true)"
          [text]="data.buttons.yes"
        >
        </vl-big-button>
      } @else {
        <!--
          ⚠️ **L'appelant décide QUELLE réponse est l'action principale**, parce que lui seul sait
          laquelle détruit quelque chose. Par défaut « Confirmer » reste plein : c'est le cas courant
          où confirmer fait avancer. Sur une question dont la confirmation JETTE du travail, l'appelant
          passe `confirmColor="error"` — le plein vert à droite ne doit pas désigner la perte.
        -->
        @if (data.extraText) {
          <vl-big-button
            data-testid="btn-extra-dialog"
            type="fit"
            [color]="data.extraColor ?? 'error'"
            (action)="onExtra()"
            [text]="data.extraText"
          >
          </vl-big-button>
        }
        <vl-big-button
          data-testid="btn-cancel-dialog"
          type="fit"
          [color]="data.cancelColor ?? 'error'"
          (action)="onCancel()"
          [text]="data.cancelText ?? ('button.cancel' | trans)"
        >
        </vl-big-button>
        <vl-big-button
          data-testid="btn-confirm-dialog"
          type="fit"
          [color]="data.confirmColor ?? 'primary'"
          (action)="onConfirm()"
          [text]="data.confirmText ?? ('button.confirm' | trans)"
        >
        </vl-big-button>
      }

    </div>
  </div>
</div>
